import {View} from 'react-native';
import {PollAnswer} from '../pollAnswer';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {Props} from './model';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {Text} from '../../../../shared/components/text';

export default ({question, style, titleStyle, disabled}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    question: {},
    questionTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5,
          marginBottom: 30,
        },
        {
          ...theme.fonts.action,
          marginBottom: 18,
        },
      ),
    },
  }));
  return (
    <View key={question.id} style={[styles.question, style]}>
      <Text testID={`question-${question.id}-text-id`} style={[styles.questionTitle, titleStyle]}>
        {question.text}
      </Text>
      {question.answers?.map((answer) => (
        <PollAnswer disabled={disabled} key={answer.id} answer={answer} question={question} />
      ))}
    </View>
  );
};
